export const SET_JOB_DATA = "SET_JOB_DATA";
export const SET_JOB_OFFICIAL = "SET_JOB_OFFICIAL";
